// src/app/app.routes.ts
import { Routes } from '@angular/router';
import { AuthGuard } from './core/services/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./core/layout/main.routes').then((m) => m.mainRoutes),
  },

  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./shared/components/auth/no-permissions/no-permissions.component').then((m) => m.NoPermissionsComponent),
  },

  { path: '**', redirectTo: '' }, // Wildcard route for 404s
];
